import React, { Component } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { flatten, find } from 'lodash';
import classNames from 'classnames';
import { Translation } from 'react-i18next';

import FuzzySearchBar from '../../../career-search/FuzzySearchBar';

const grid = 8;

const getClassListItemStyle = (
  virtualListStyle,
  draggableStyle,
  borderColor,
  isDragging
) => {
  const combinedStyles = {
    ...draggableStyle,
    ...virtualListStyle,
  };

  const marginBottom = 5;

  return {
    ...combinedStyles,
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    border: `1px solid ${borderColor}`,
    borderRadius: '9px',
    color: 'black',
    fontSize: '11px',
    backgroundColor: 'white',
    boxShadow: isDragging ? '0px 5px 5px grey' : null,
    overflow: 'visible',
    alignItems: 'center',
    height: isDragging
      ? combinedStyles.height
      : combinedStyles.height - marginBottom,
    display: 'flex',
  };
};

function Item({ primary, provided, course, isDragging, style }) {
  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <div
      className="class-list-draggable"
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={getClassListItemStyle(
        style,
        provided.draggableProps.style,
        primary,
        isDragging
      )}
    >
      <div className="class-list-draggable-text">
        <p className="truncated-class-text-classlist">
          {course.requirement_title}
        </p>
      </div>
    </div>
  );
  /* eslint-enable react/jsx-props-no-spreading */
}

function createTenantRow(primary) {
  return ({ data: items, index, style }) => {
    const course = items[index];

    return (
      <Draggable
        key={`unplaced-${course.requirement_title}-${index}`}
        draggableId={`${course.class_id}`}
        index={index}
      >
        {(provided) => (
          <Item
            provided={provided}
            course={course}
            primary={primary}
            style={style}
          />
        )}
      </Draggable>
    );
  };
}

class ClassList extends Component {
  constructor(props) {
    super(props);

    this.Row = createTenantRow(this.props.tenant.primary);

    this.state = {
      searchResults: [],
    };
  }

  get placedClasses() {
    return this.props.placedClasses;
  }

  get allClasses() {
    return this.props.allClasses;
  }

  get listOfClasses() {
    const availableClasses = this.getFilteredListOfClasses(this.allClasses);

    return availableClasses;
  }

  getFilteredListOfClasses = (classList) => {
    const placedClasses = flatten(Object.values(this.placedClasses));
    const filteredClasses = Object.values(classList).filter((eachClass) => {
      return !find(placedClasses, eachClass);
    });

    return filteredClasses;
  };

  get searchResults() {
    return this.state.searchResults;
  }

  get classList() {
    return this.searchResults && this.searchResults.length > 0
      ? this.getFilteredListOfClasses(this.searchResults)
      : this.listOfClasses;
  }

  setSearchResults = (searchResults) => this.setState({ searchResults });

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="search-bar-class-list-container">
            <div className="class-list-search-container">
              <FuzzySearchBar
                tenant={this.props.tenant}
                listToSearch={this.listOfClasses}
                sendFilteredListToParent={this.setSearchResults}
                setSearchListLoadingOnParent={() => {}}
                overRideStylesSearchBar="ecap-classes-search-bar"
                overRideStylesMag={classNames({
                  'ecap-mag-glass': !this.props.yearViewOpen,
                  'ecap-mag-glass-open-view': this.props.yearViewOpen,
                })}
                inputText={t('Search', { context: 'action' })}
                searchKeys={['requirement_title']}
              />
            </div>

            <Droppable
              droppableId="classList"
              mode="virtual"
              isDropDisabled
              renderClone={(provided, snapshot, rubric) => (
                <Item
                  provided={provided}
                  isDragging={snapshot.isDragging}
                  primary={this.props.tenant.primary}
                  course={this.classList[rubric.source.index]}
                />
              )}
            >
              {(provided) => (
                <AutoSizer defaultWidth={1} defaultHeight={1}>
                  {({ height, width }) => (
                    <FixedSizeList
                      height={height}
                      itemCount={this.classList.length}
                      itemSize={60}
                      width={width}
                      outerRef={provided.innerRef}
                      itemData={this.classList}
                    >
                      {this.Row}
                    </FixedSizeList>
                  )}
                </AutoSizer>
              )}
            </Droppable>
          </div>
        )}
      </Translation>
    );
  }
}

export default ClassList;
